import axios from 'axios';
import { getApiBaseUrl, getApiClient } from '../services/serviceconfig';

export function getMediaBaseUrl() {
    return getApiBaseUrl().replace(/\/api\/?$/, '');
}

function resolveMediaUrl(mediaPath) {
    if (!mediaPath) {
        return null;
    }
    if (/^https?:\/\//i.test(mediaPath)) {
        return mediaPath;
    }
    const base = getMediaBaseUrl();
    const path = mediaPath.startsWith('/') ? mediaPath : `/${mediaPath}`;
    return `${base}${path}`;
}

export async function fetchImageDataUrl(cookies, mediaPath) {
    const url = resolveMediaUrl(mediaPath);
    if (!url) {
        return null;
    }
    const response = cookies
        ? await getApiClient(cookies).get(url, { responseType: 'blob' })
        : await axios.get(url, { responseType: 'blob' });
    const blob = response.data;
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(blob);
    });
}
